// extracted by mini-css-extract-plugin
export default {"center_box":"NetworkError_center_box__JyNME","error_text":"NetworkError_error_text__OQQyX"};